module.exports = __webpack_public_path__ + "img/icon-client-card@3x.402eb6b5.png";